<template>
	<div class="role">
		<div class="" v-if="!isEdit">
			<div class="qjc-flex query-wrap">
				<el-input class="search-input" v-model="nowMobile" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入手机号或用户ID">
					<div class="search-icon" slot="prefix">
						<i class="el-icon-search"></i>
					</div>
				</el-input>
				<el-button @click="query" :loading="submiting" class="query-btn qjc-fts-16">查询</el-button>
			</div>
			<div class="">
				<el-table
					:data="user"
					stripe
					class="list"
				>
					<el-table-column
						label="套餐内容"
						width="300px"
						class-name="package"
					>
						<template slot-scope="scope">
							<div class="package-cell" :title="scope.row.package == '2' ? (scope.row.custom.join('+').replace('base','基础体检套餐').replace('packageA','增值包-同族群PLM对比').replace('packageB','增值包-共病风险').replace('packageC','增值包-疾病风险远期预测').replace('packageD','增值包-健康促进方案').replace('packageFB','增值包-骨折风险评估')) : (scope.row.package == '1' ? '健康100' : scope.row.package == '3' ? '馨康母婴套餐' : '')">
								{{scope.row.package == '2' ? (scope.row.custom.join('+').replace('base','基础体检套餐').replace('packageA','增值包-同族群PLM对比').replace('packageB','增值包-共病风险').replace('packageC','增值包-疾病风险远期预测').replace('packageD','增值包-健康促进方案').replace('packageFB','增值包-骨折风险评估')) : (scope.row.package == '1' ? '健康100' : scope.row.package == '3' ? '馨康母婴套餐' : '')}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="examdate"
						fixed
						width="200px"
						label="手机号"
						class-name="examdate"
					>
					</el-table-column>
					<el-table-column
						prop="examdate"
						fixed
						width="200px"
						label="企业用户ID"
						class-name="examdate"
					>
					</el-table-column>
					<el-table-column
						prop="sex"
						label="性别"
						class-name="sex"
						width="100px"
					>
					</el-table-column>
				<!-- 	<el-table-column
						prop="examdate"
						fixed
						width="200px"
						label="体检日期"
						class-name="examdate"
					> -->
					</el-table-column>
					<el-table-column
						prop="birth"
						label="出生日期"
						class-name="birth"
					>
					</el-table-column>
					<el-table-column
						prop="sex"
						label="状态"
						class-name="sex"
					>
						<template slot-scope="scope">
							<div class="" v-if="scope.row.sex == 1">
								未体检
							</div>
							<div class="" v-if="scope.row.sex == 2">
								已完成
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="action"
						label="操作"
						class-name="sex"
					>
						<template slot-scope="scope">
							<div class="action-btn  action-btn-end" @click="handleUpdate(scope.row.id)">
								修改
							</div>
						</template>
					</el-table-column>
					
					<!-- <el-table-column
						class-name="oper"
						align="center"
					>
						<template slot-scope="scope">
							<el-button @click="lookReport(scope.row)" type="text">查看报告</el-button>
							<el-button @click="download(scope.row.id)" type="text">下载报告</el-button>
							<el-button @click="print(scope.row.id)">一键打印</el-button>
						</template>
					</el-table-column> -->
					
				</el-table>
				
				<!-- 分页 -->
				<el-pagination
					class="pagination qjc-texta-c"
					layout="prev, pager, next"
					hide-on-single-page
					:current-page.sync="pager.page"
					:page-count="pager.pagecount"
					:page-size="pager.pagesize"
					:total="pager.count"
					@current-change="pageChange">
				</el-pagination>
			</div>
			
		</div>
		
		<div class="open-wrap" v-if="isEdit">
			<new-Insert type="update" :clearData="clearData" :formData="formData" ></new-Insert>
		</div>
	</div>
</template>

<script>
	import { adminRole, printBatchQuery } from "@/utils/axios"
	import NewInsert from '@/components/NewInsert'
	
	export default{
		name: 'adminDataUpdate',
		components: {
			NewInsert
		},
		data() {
			return {
				isEdit: false,
				user: [],
				formData: {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: ['base'],
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"},
						{"KDIS": "K14", "LEVEL": "0"},
						{"KDIS": "K15", "LEVEL": "0"},
						{"KDIS": "K16", "LEVEL": "0"},
						{"KDIS": "K17", "LEVEL": "0"},
						{"KDIS": "K18", "LEVEL": "0"},
						{"KDIS": "K19", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: ''// 当前后台操作人手机号
				},
				rules: {
					name: [
						{ required: true, message: '角色名称不能为空', trigger: 'blur' }
					],
					power: [
						{ required: true, message: '请至少选择一项', trigger: 'change' }
					]
				},
				user: [],// 客户信息
				
				submiting: false,//正在请求
				
				pager: {
					count: 0,
					page: 1,// 默认第一页
					pagecount: 0,
					pagesize: 12//默认一页12条数据
				},
				
				nowMobile: '',// 存储当前已查询企业用户id或手机号
			}
		},
		mounted() {
			this.getList()
		},
		watch:{
			
		},
		methods: {
			clearData() {
				this.formData = {
					mobile: '',
					yyuserid: '',
					sex: '',
					birth: '',
					examdate: '',
					examplace: '',
					package: ['base'],
					
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					operator: '',// 当前后台操作人手机号
				}
			},
			
			query() {
				// 正在请求
				this.submiting == true;
				this.getList();
			},
			
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			
			getList() {
				printBatchQuery({
					mobile: this.nowMobile,
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}).then(res => {
					if(res.code == 200){
						this.submiting == false;
						if(res.data.data.length == 0){
							this.user = [];
							this.pager = {
								count: 0,
								page: 1,// 默认第一页
								pagecount: 0,
								pagesize: 12//默认一页12条数据
							},
							this.$myAlert({
								title: res.msg
							});
						}else{
							this.user = res.data.data;
							
							//分页
							var pager = res.data.pager;
							for(var key in pager){
								pager[key] = parseInt(pager[key]);
							}
							this.pager = pager;
						}
					}else{
						this.submiting == false;
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
			
			handleUpdate(id) {
				// 数据修改
				this.isEdit = true;
			},
			
		}
	}
</script>

<style scoped>
	/* .role >>> .el-table th {
		height: 38px;
		padding: 0;
		background-color: #F7F9FC;
	}
	.role >>> .el-table td {
		height: 38px;
		padding: 0;
	} */
	
	.query-wrap >>> .el-input__inner {
		height: 36px;
	}
</style>
<style lang="scss" scoped>
	.role{
		padding: 24px;
		width: 100%;
		height: 100%;
		overflow-y: auto;
		border: 12px solid #F2F4FA;
		
		.query-btn {
			width: 72px;
			height: 36px;
			line-height: 36px;
			font-size: 15px;
			padding: 0;
			margin-left: 16px;
			border: none;
		}
		
		.list{
			margin-top: 16px;
			
			&::before{
				display: none;
			}
			.el-button{
				font-size: 14px;
				padding: 6px 8px;
				
				+.el-button{
					margin-left: 24px;
				}
			}
			
			.package-cell {
				white-space:nowrap;
				overflow:hidden;
				text-overflow:ellipsis;
			}
		}
		
		.action-btn {
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			cursor: pointer;
		}
		.action-btn-end {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #B4BBCC;
		}
		
		.pagination{
			margin-top: 24px;
			padding-right: 24px;
			text-align: center;
		}
		
		.search-input {
			width: 458px;
			height: 34px;
		}
		
		.search-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 26px;
			height: 40px;
		}
		
		.el-dialog{
			
			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}
			.all-power{
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645,.045,.355,1);
				width: 100%;
			}
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					padding: 9px 15px;
				}
			}
		}
	}
</style>
